import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmCompetencyTypeForm from '../../../components/forms/FirearmCompetencyTypeForm';
import { useCreateFirearmCompetencyType } from '../../../hooks/useFirearmCompetencyTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmCompetencyTypeDTO } from '../../../services/apiClient';

const FirearmCompetencyTypeCreate: React.FC = () => {
  const createFirearmCompetencyType = useCreateFirearmCompetencyType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Competency Types', href: '/admin/firearmcompetencytypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FirearmCompetencyTypeDTO) => {
    try {
      await createFirearmCompetencyType.mutateAsync(data);
      navigate('/admin/firearmcompetencytypes');
    } catch (error) {
      console.error('Error creating FirearmCompetencyType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmcompetencytypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmCompetencyType.Edit'
    >
        <FirearmCompetencyTypeForm
          initialValues={{} as FirearmCompetencyTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/firearmcompetencytypes')}
        />
    </AdminLayout>
  );
};

export default FirearmCompetencyTypeCreate;